import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { EmailSequence } from 'src/app/models/email-sequence.model';
import { SelectableCompany } from 'src/app/models/company.model';
import { RolePermissionsService } from 'src/app/services/role-permissions.service';
import { RequiresCapabilityDirective } from 'src/app/directives/requires-capability.directive';
import { Integration } from 'src/app/models/integration.model';

@Component({
  selector: 'app-email-sequence-table',
  templateUrl: './email-sequence-table.component.html',
  styleUrls: ['./email-sequence-table.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    TagModule,
    TooltipModule,
    RequiresCapabilityDirective
  ]
})
export class EmailSequenceTableComponent {
  @Input() sequences: EmailSequence[] = [];
  @Input() loading = false;
  @Input() currentCompany: SelectableCompany | null = null;
  @Input() selectedIntegration: Integration | string | null = null;  // For capability checks
  @Input() canEditSequences = false;
  @Input() canDeleteSequences = false;
  @Input() canManageSequences = false;

  @Output() sequenceStarted = new EventEmitter<EmailSequence>();
  @Output() sequencePaused = new EventEmitter<EmailSequence>();
  @Output() sequenceEdited = new EventEmitter<EmailSequence>();
  @Output() sequenceDeleted = new EventEmitter<{ event: Event, sequence: EmailSequence }>();
  @Output() sequenceMetricsViewed = new EventEmitter<EmailSequence>();
  @Output() sequenceDetailsViewed = new EventEmitter<EmailSequence>();
  @Output() prospectModalShown = new EventEmitter<EmailSequence>();
  @Output() newSequenceClicked = new EventEmitter<Event>();

  getSeverity(status: string): 'success' | 'info' | 'warn' | 'danger' | 'secondary' {
    switch (status) {
      case 'active':
        return 'success';
      case 'paused':
        return 'warn';
      case 'draft':
        return 'info';
      case 'completed':
        return 'secondary';
      default:
        return 'info';
    }
  }

  onStartSequence(sequence: EmailSequence): void {
    this.sequenceStarted.emit(sequence);
  }

  onPauseSequence(sequence: EmailSequence): void {
    this.sequencePaused.emit(sequence);
  }

  onEditSequence(sequence: EmailSequence): void {
    this.sequenceEdited.emit(sequence);
  }

  onDeleteSequence(event: Event, sequence: EmailSequence): void {
    this.sequenceDeleted.emit({ event, sequence });
  }

  onViewMetrics(sequence: EmailSequence): void {
    this.sequenceMetricsViewed.emit(sequence);
  }

  onViewDetails(sequence: EmailSequence): void {
    this.sequenceDetailsViewed.emit(sequence);
  }

  onShowProspectModal(sequence: EmailSequence): void {
    this.prospectModalShown.emit(sequence);
  }

  onNewSequenceClick(event: Event): void {
    this.newSequenceClicked.emit(event);
  }
}